import React, { useRef, useState, useEffect } from 'react';

const AudioPlayer = () => {
  const [hasStarted, setHasStarted] = useState(false);
  const audioRef1 = useRef(null);
  const audioRef2 = useRef(null);

  useEffect(() => {
    const handleFirstClick = () => {
      // Check if the user is on the /holy page
      if (window.location.pathname === '/holy.php' || window.location.pathname === '/holy.html') return;

      if (!hasStarted) {
        setHasStarted(true);
        const audio1 = audioRef1.current;
        const audio2 = audioRef2.current;
        if (audio1) {
          audio1.play().catch((error) => {
            console.error('Error playing first audio:', error);
          });
        }
        if (audio2) {
          audio2.play().catch((error) => {
            console.error('Error playing second audio:', error);
          });
        }
      }
    };

    window.addEventListener('click', handleFirstClick);

    return () => {
      window.removeEventListener('click', handleFirstClick);
    };
  }, [hasStarted]);

  useEffect(() => {
    // Check if the user is on the /holy page
    if (window.location.pathname === '/holy.php' || window.location.pathname === '/holy.html') {
      // Play the specific audio for the /holy page
      if (audioRef1.current) {
        audioRef1.current.pause();
        audioRef1.current.src = ''; // Clear the src to ensure it does not play
      }

      // Stop audioRef2 from playing
      if (audioRef2.current) {
        audioRef2.current.pause();
        audioRef2.current.src = ''; // Clear the src to ensure it does not play
      }

      return; // Stop further setup for other audio if on the /holy page
    }

    // Setup for other audio files if not on the /holy page
    const audioFiles = [
      'asukaa.mp3',
      'black.mp3',
      'nier.mp3',
      'seagull.mp3',
      'sinkiesn.mp3',
      'snow.ogg'
    ];

    if (audioRef1.current && audioRef2.current) {
      audioRef1.current.loop = true;
      audioRef1.current.volume = 0.15;

      audioRef2.current.loop = true;
      audioRef2.current.volume = 0.02;

      // Randomly select an audio file for audioRef2
      const randomIndex = Math.floor(Math.random() * audioFiles.length);
      const randomAudioFile = audioFiles[randomIndex];
      
      if (audioRef2.current) {
        audioRef2.current.src = `https://piraditedot.vercel.app/${randomAudioFile}`;
      }
    }
  }, []);

  return (
    <div>
      <audio
        ref={audioRef1}
        preload="auto"
      >
        <source src="./alone.mp3" type="audio/mp3" />
        Your browser does not support the <code>audio</code> element.
      </audio>
      <audio
        ref={audioRef2}
        preload="auto"
      >
        Your browser does not support the <code>audio</code> element.
      </audio>
    </div>
  );
};

export default AudioPlayer;
